export class UserMetadata {
    public static readonly USER_METADATA_FINANCING_RELATIONSHIP_KEY = 'financingRelationshipKey';
}
